import { CookieService } from './cookie.service';
export function cookieServiceFactory(cookieOptionsProvider) {
    return new CookieService(cookieOptionsProvider);
}



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/~/ngx-cookie/src/cookie.factory.js
// module id = ../../../../ngx-cookie/src/cookie.factory.js
// module chunks = 3